<div class="o-grid">
    <div class="o-grid__cell o-grid__cell--w-100">
        <p class="c-section__title c-section__title--sm">{{ vm.titleText }}</p>
    </div>
</div>
<div class="o-grid" *ngIf="!vm.rootTopics">
    <div class="o-grid__cell o-grid__cell--w-100">
        <p class="c-text u-osb-lg">{{'Booking.Instant.Text_Coaching_Topics_Guide' | translate }}</p>
    </div>
</div>
<div class="o-grid o-grid--wrap">
   <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-osb-md" *ngFor="let coachingTopic of vm.displayedCoachingTopics">
        <card-coaching-topic [coachingTopic]="coachingTopic" [selectionHandler]="vm.handleSelection"></card-coaching-topic>
    </div>
</div>
<div class="o-grid o-grid--right" *ngIf="vm.user?.origin == 'minudoc.ee' || !vm.rootTopics">
     <div class="o-grid__cell o-grid__cell--w-fixed u-ost-lg u-osb-lg">
         <a id="coachingTopicsNavigateBackButton" href="javascript:void(0)" (click)="vm.navigateBack()" class="c-button c-button--md c-button--s2 c-button--fit">{{'Common.Back' | translate }}</a>
     </div>
</div>
<br/>
